import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button, Toast, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import {
	IoIosClose,
	IoMdDownload,
	IoMdDoneAll,
	IoMdCreate,
	IoMdCalendar,
	IoMdTrash,
} from "react-icons/io";
import ReactTable from "../../../../components/FilterTable";
import { _HttpServices } from "../../../../_services/_HttpServices";
import Loader from "../../../../components/Loader";
// import Loader from "../../components/Loader";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import moment from "moment";
import { useHistory } from "react-router";
import getExcel from "../../../../_services/ExcelUtility";
import { Footer } from "../../../../components/Footer";

const AptevoQuarterlyServiceFeesEdit = (props) => {
	let fileName = "Aptevo Quarterly ServiceFees";
	const outbounddata = JSON.parse(localStorage.getItem("outboundreport"));
	// const userData = localStorage.getItem('userData');
	const salesSource = JSON.parse(localStorage.getItem("salesSource"));
	const userData = localStorage.getItem("userData");
	const history = useHistory();
	const [gridData, setGridData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [hasError, setHasError] = useState(false);
	const [showCOnfirm, setShowConfirm] = useState(false);
	const [addshowConfirm, setaddShowConfirm] = useState(false);
	// const [chargeback, setChargeBack] = useState({})
	const [sales, setSales] = useState({});
	const [indicator, setIndicator] = useState(false);
	const [editOrSaveInd, setEditOrSaveInd] = useState(false);
	const [disableSubmit, setSubmitDisable] = useState(false);
	const [addDisableSubmit, setAddSubmitDisable] = useState(false);
	const [showToaster, setShowToaster] = useState(false);
	const initialvalues = {
		DistributorName: "",
		DistributionLocationState: "",
		DebitMemoNum: "",
		CustID: "",
		CustPHSID: "",
		CustName: "",
		CustAddress: "",
		CustCity: "",
		CustState: "",
		CustZip: "",
		CustomersInvoice: "",
		ContractReference: "",
		ProductNDC: "",
		ProductDescription: "",
		SaleQTY: "",
		SaleQTYUOM: "",
		DosagORUnitstabs30: "",
		DosageORUnitsUMO: "",
		Totalcount: "",
		AcquisitionCost: "",
		ContractPrice: "",
		CIBDExtendedAmount: "",
		ADMFees40: "",
		ADMFees5: "",
		ADMFees70: "",
		ADMFees30: "",
		TwoPercentServiceFees: "",
	};
	// const [newChargeBack, setNewChargeBack] = useState(initialvalues);
	const [newSales, setNewSales] = useState(initialvalues);
	const [editIndex, setEditIndex] = useState();

	//
	const Gridcolumns = [
		{
			Header: "Actions",
			accessor: "accessor",
			disableFilters: true,
			disableSortBy: true,
			width: 130,
			accessor: "accessor",

			Cell: (row) => (
				<Fragment>
					<Button
						variant="link"
						onClick={() => editReport(row)}
						className="grid-action-btn ml-2"
						title="Edit Row"
					>
						<IoMdCreate className="icon" />
					</Button>
					<Button
						variant="link"
						onClick={() => deleteRecord(row)}
						className="grid-action-btn ml-2"
						title="Delete Row"
					>
						<IoMdTrash className="icon fa-icon" />
					</Button>
					{/* <Button variant="link" onClick={() => copyReport(row.row.original)} className="grid-action-btn ml-2" title="Disable Task">
                        <IoMdCreate className="icon" />
                    </Button> */}
				</Fragment>
			),
		},

		{
			Header: "DISTRIBUTOR NAME",
			accessor: "DistributorName",
			filter: "DistributorName",
			sortType: "basic",
			key: true,
		},
		{
			Header: "DISTRIBUTION LOCATION STATE",
			accessor: "DistributionLocationState",
			filter: "DistributionLocationState",
			sortType: "basic",
			key: true,
		},
		{
			Header: "REPORT DATE",
			accessor: "ReportDate",
			filter: "ReportDate",
			sortType: "basic",
			filterMethod: (filter, row) => {
				const rowValue = row.original;
				return rowValue.datefiled.includes(filter.value);
			},
			key: true,
			field: true,
		},

		{
			Header: "DEBIT MEMO#",
			accessor: "DebitMemoNum",
			filter: "DebitMemoNum",
			sortType: "basic",
			key: true,
		},
		{
			Header: "Customer Hin",
			accessor: "CustID",
			filter: "CustID",
			sortType: "basic",
			key: true,
		},
		{
			Header: "CB CUST PHS ID#",
			accessor: "CustPHSID",
			filter: "CustPHSID",
			sortType: "basic",
			key: true,
		},
		{
			Header: "CUSTOMER NAME",
			accessor: "CustName",
			filter: "CustName",
			sortType: "basic",
			width: 350,
			key: true,
		},
		{
			Header: "CUSTOMER ADDRESS",
			accessor: "CustAddress",
			filter: "CustAddress",
			sortType: "basic",
			width: 300,
			key: true,
		},
		{
			Header: "CUSTOMER CITY",
			accessor: "CustCity",
			filter: "CustCity",
			sortType: "basic",
			key: true,
		},
		{
			Header: "CUSTOMER STATE",
			accessor: "CustState",
			filter: "CustState",
			sortType: "basic",
			key: true,
		},
		{
			Header: "CUSTOMER ZIP",
			accessor: "CustZip",
			filter: "CustZip",
			sortType: "basic",
			key: true,
		},
		{
			Header: "CUSTOMER'S INVOICE#",
			accessor: "CustomersInvoice",
			filter: "CustomersInvoice",
			sortType: "basic",
			key: true,
		},
		{
			Header: "CUSTOMER'S INVOICE DATE",
			accessor: "CustomersInvoiceDate",
			filter: "CustomersInvoiceDate",
			sortType: "basic",
			key: true,
			field: true,
		},
		{
			Header: "CONTRACT REFERENCE",
			accessor: "ContractReference",
			filter: "ContractReference",
			sortType: "basic",
			key: true,
		},
		{
			Header: "PRODUCT NDC-11",
			accessor: "ProductNDC",
			filter: "ProductNDC",
			sortType: "basic",
			key: true,
		},
		{
			Header: "PRODUCT DESCRIPTION",
			accessor: "ProductDescription",
			filter: "ProductDescription",
			sortType: "basic",
			width: 300,
			key: true,
		},
		{
			Header: "SALE QTY",
			accessor: "SaleQTY",
			filter: "SaleQTY",
			sortType: "basic",
			key: true,
		},
		{
			Header: "SALE QTY UOM",
			accessor: "SaleQTYUOM",
			filter: "SaleQTYUOM",
			sortType: "basic",
			key: true,
		},
		{
			Header: "DOSAGE / UNITS",
			accessor: "DosagORUnitstabs30",
			filter: "DosagORUnitstabs30",
			sortType: "basic",
			key: true,
		},
		{
			Header: "DOSAGE / UNITS UOM",
			accessor: "DosageORUnitsUMO",
			filter: "DosageORUnitsUMO",
			sortType: "basic",
			key: true,
		},
		{
			Header: "Total IUs",
			accessor: "Totalcount",
			filter: "Totalcount",
			sortType: "basic",
			key: true,
		},
		{
			Header: "ACQUISITION COST per IU/EU/Gram",
			accessor: "AcquisitionCost",
			filter: "AcquisitionCost",
			sortType: "basic",
			key: true,
		},
		{
			Header: "CONTRACT PRICE per IU/EU/Gram",
			accessor: "ContractPrice",
			filter: "ContractPrice",
			sortType: "basic",
			key: true,
		},
		{
			Header: "CIBD Extended Amount",
			accessor: "CIBDExtendedAmount",
			filter: "CIBDExtendedAmount",
			sortType: "basic",
			key: true,
		},
		{
			Header: "2% Service Fees",
			accessor: "TwoPercentServiceFees",
			filter: "TwoPercentServiceFees",
			sortType: "basic",
			key: true,
		},
	];

	//

	//
	useEffect(() => {
		// getAdvanceShipNotice();
		setGridData(salesSource);
	}, []);

	const handleChange = (e) => {
		const { name, value } = e.target;
		console.log(e);
		if (
			name === "SaleQTY" ||
			name === "ProductNDC" ||
			name === "AcquisitionCost" ||
			name === "Totalcount" ||
			name === "ContractPrice" ||
			name === "CIBDExtendedAmount" ||
			name === "CustomersInvoice" ||
			name === "TwoPercentServiceFees"
		) {
			const re = /^[($)\d\.,-]+$/;
			if (value === "" || re.test(value)) {
				setSales((values) => ({
					...values,
					[name]: value,
				}));
			}
		} else {
			setSales((values) => ({
				...values,
				[name]: value.replace(/\s{2,}/g, " "),
			}));
		}
	};
	const newhandleChange = (e) => {
		const { name, value } = e.target;
		console.log(e);
		if (
			name === "SaleQTY" ||
			name === "ProductNDC" ||
			name === "AcquisitionCost" ||
			name === "Totalcount" ||
			name === "ContractPrice" ||
			name === "CIBDExtendedAmount" ||
			name === "CustomersInvoice" ||
			name === "TwoPercentServiceFees"
		) {
			const re = /^[($)\d\.,-]+$/;
			if (value === "" || re.test(value)) {
				setNewSales((values) => ({
					...values,
					[name]: value.trim(),
				}));
			}
		} else {
			setNewSales((values) => ({
				...values,
				[name]: value.replace(/\s{2,}/g, " "),
			}));
		}
	};
	function copyReport(row) {
		// delete gridSales[row.row.index];
		let obj = Object.assign({}, row);
		obj.ind = gridData.length + 1;
		const row1 = Object.assign({}, obj);
		gridData.push(row1);
		const deletedData = Object.assign([], gridData);
		setGridData(deletedData);
	}
	function deleteRecord(row) {
		console.log(row.row.original);

		// delete gridData[row.row.index];
		let data = gridData.filter((element, index) => {
			return index !== row.row.index;
		});
		const deletedData = Object.assign([], data);
		setGridData(deletedData);
	}
	const handleChangeDate = (date, i) => {
		const re = i;
		setSales((values) => ({
			...values,
			ReportingDate: date,
		}));
	};

	useEffect(() => {
		setSubmitDisable(validateForm());
	}, [newSales]);
	useEffect(() => {
		setAddSubmitDisable(validateEditForm());
	}, [sales]);

	const validateEditForm = () => {
		if (
			sales.DistributorName &&
			sales.DistributorName.toString().trim() !== "" &&
			sales.DistributionLocationState &&
			sales.DistributionLocationState.toString().trim() !== "" &&
			sales.DebitMemoNum &&
			sales.DebitMemoNum.toString().trim() !== "" &&
			sales.CustID &&
			sales.CustID.toString().trim() !== "" &&
			sales.CustPHSID &&
			sales.CustPHSID.toString().trim() !== "" &&
			sales.CustName &&
			sales.CustName.toString().trim() !== "" &&
			sales.CustAddress &&
			sales.CustAddress.toString().trim() !== "" &&
			sales.CustCity &&
			sales.CustCity.toString().trim() !== "" &&
			sales.CustState &&
			sales.CustState.toString().trim() !== "" &&
			sales.CustZip &&
			sales.CustZip.toString().trim() !== "" &&
			sales.CustomersInvoice &&
			sales.CustomersInvoice.toString().trim() !== "" &&
			sales.ContractReference &&
			sales.ContractReference.toString().trim() !== "" &&
			sales.ProductNDC &&
			sales.ProductNDC.toString().trim() !== "" &&
			sales.ProductDescription &&
			sales.ProductDescription.toString().trim() !== "" &&
			(sales.SaleQTY || sales.SaleQTY === 0) &&
			sales.SaleQTY.toString().trim() !== "" &&
			sales.SaleQTYUOM &&
			sales.SaleQTYUOM.toString().trim() !== "" &&
			sales.DosagORUnitstabs30 &&
			sales.DosagORUnitstabs30.toString().trim() !== "" &&
			sales.DosageORUnitsUMO &&
			sales.DosageORUnitsUMO.toString().trim() !== "" &&
			sales.Totalcount &&
			sales.Totalcount.toString().trim() !== "" &&
			sales.AcquisitionCost &&
			sales.AcquisitionCost.toString().trim() !== "" &&
			sales.ContractPrice &&
			sales.ContractPrice.toString().trim() !== "" &&
			sales.CIBDExtendedAmount &&
			sales.CIBDExtendedAmount.toString().trim() !== "" &&
			sales.TwoPercentServiceFees &&
			sales.TwoPercentServiceFees.toString().trim() !== ""
		) {
			return false;
		} else {
			return true;
		}
	};
	const validateForm = () => {
		if (
			newSales.DistributorName &&
			newSales.DistributorName.toString().trim() !== "" &&
			newSales.DistributionLocationState &&
			newSales.DistributionLocationState.toString().trim() !== "" &&
			newSales.DebitMemoNum &&
			newSales.DebitMemoNum.toString().trim() !== "" &&
			newSales.CustID &&
			newSales.CustID.toString().trim() !== "" &&
			newSales.CustPHSID &&
			newSales.CustPHSID.toString().trim() !== "" &&
			newSales.CustName &&
			newSales.CustName.toString().trim() !== "" &&
			newSales.CustAddress &&
			newSales.CustAddress.toString().trim() !== "" &&
			newSales.CustCity &&
			newSales.CustCity.toString().trim() !== "" &&
			newSales.CustState &&
			newSales.CustState.toString().trim() !== "" &&
			newSales.CustZip &&
			newSales.CustZip.toString().trim() !== "" &&
			newSales.CustomersInvoice &&
			newSales.CustomersInvoice.toString().trim() !== "" &&
			newSales.ContractReference &&
			newSales.ContractReference.toString().trim() !== "" &&
			newSales.ProductNDC &&
			newSales.ProductNDC.toString().trim() !== "" &&
			newSales.ProductDescription &&
			newSales.ProductDescription.toString().trim() !== "" &&
			(newSales.SaleQTY || newSales.SaleQTY === 0) &&
			newSales.SaleQTY.toString().trim() !== "" &&
			newSales.SaleQTYUOM &&
			newSales.SaleQTYUOM.toString().trim() !== "" &&
			newSales.DosagORUnitstabs30 &&
			newSales.DosagORUnitstabs30.toString().trim() !== "" &&
			newSales.DosageORUnitsUMO &&
			newSales.DosageORUnitsUMO.toString().trim() !== "" &&
			newSales.Totalcount &&
			newSales.Totalcount.toString().trim() !== "" &&
			newSales.AcquisitionCost &&
			newSales.AcquisitionCost.toString().trim() !== "" &&
			newSales.ContractPrice &&
			newSales.ContractPrice.toString().trim() !== "" &&
			newSales.CIBDExtendedAmount &&
			newSales.CIBDExtendedAmount.toString().trim() !== "" &&
			newSales.TwoPercentServiceFees &&
			newSales.TwoPercentServiceFees.toString().trim() !== ""
		) {
			return false;
		} else {
			return true;
		}
	};
	function saveRowHandler() {
		// newSales.ind=0;
		if (!editOrSaveInd) {
			newSales.ReportDate = moment(
				newSales.ReportDate ? newSales.ReportDate : new Date()
			).format("MM/DD/YYYY");
			newSales.CustomersInvoiceDate = moment(
				newSales.CustomersInvoiceDate
					? newSales.CustomersInvoiceDate
					: new Date()
			).format("MM/DD/YYYY");
			const ns = Object.assign({}, newSales);
			gridData.unshift(ns);
			setaddShowConfirm(false);
			setNewSales(initialvalues);
		}
	}
	function editRowHandler() {
		let indicator = 0;
		sales.ReportDate = moment(
			sales.ReportDate ? sales.ReportDate : new Date()
		).format("MM/DD/YYYY");
		sales.CustomersInvoiceDate = moment(sales.CustomersInvoiceDate).format(
			"MM/DD/YYYY"
		);
		// if (sales.CustID && sales.CustID) {

		// gridSales[cont.ind-1] =cont;
		if (editOrSaveInd) {
			gridData.filter((element, index) => {
				if (editIndex === index) {
					const cbk = Object.assign({}, sales);
					gridData[index] = cbk;
				}
			});
		}

		indicator = 1;
		// }

		if (indicator != 0) {
			// console.log(chargeback)
			setShowConfirm(false);
			setIndicator(false);
		} else {
			setIndicator(true);
		}
	}
	const editReport = (contacts) => {
		// setDeleteTask(task)
		setEditIndex(contacts.row.index);
		setSales(contacts.row.original);
		setShowConfirm(true);
		setEditOrSaveInd(true);
	};

	const EditRecords = () => {
		// setShowConfirm(true);
		// setGridShow(true);
	};
	const saveRecords = () => {
		//    setCont({})
		// setShowConfirm(true);
		setaddShowConfirm(true);
		setEditOrSaveInd(false);
	};

	const saveallRecords = () => {
		gridData.map((element) => {
			element.FileProcessID = salesSource[0].FileProcessID;
			element.ModifiedOn = new Date();
			element.LastModifiedBy = JSON.parse(userData).UserName;
			element.IsResendRequired =
				outbounddata.FileSentStatus == "Sent" ? true : false;
			element.IsReadyforReversal = true;
			element.IsEdited = true;
			element.Version = 1;
			element.Service_Task_Id = outbounddata.ServiceTaskID;
			element.AcquisitionCost = element.AcquisitionCost.replace("$", "");
			element.ContractPrice = element.ContractPrice.replace("$", "");
			element.CIBDExtendedAmount = element.CIBDExtendedAmount.replace("$", "");
		});

		setLoading(true);
		_HttpServices
			.postData("Api/Edi844/Reversal857ServiceFeesReportExcel", gridData)
			.then((data) => {
				if (data.data === "") {
					setLoading(false);
					setShowToaster(true);
					setTimeout(() => history.push("/outbound-reports"), 1000);
				}
			})
			.catch((e) => {
				setLoading(false);
			});
	};
	return (
		<section className="content">
			<div className="page-title">
				<h2 className="h2">{fileName}</h2>
				{loading ? <Loader /> : null}
				<Toast
					onClose={() => setShowToaster(false)}
					show={showToaster}
					delay={1500}
					autohide
					className="custom-toaster"
				>
					<Toast.Body>Details updated successfully</Toast.Body>
				</Toast>
				<div>
					<Button variant="primary" type="button" onClick={() => saveRecords()}>
						Add Record
					</Button>
					{/* <Button type="submit" onClick={() =>EditRecords()}>EditRecords</Button> */}

					<Button
						className="ml-2"
						type="submit"
						onClick={() => getExcel(Gridcolumns, gridData, fileName)}
					>
						<IoMdDownload className="icon btn-icon" />
						Download Excel{" "}
					</Button>
				</div>
				{/* insert */}

				<Modal
					show={addshowConfirm}
					onHide={() => setaddShowConfirm(false)}
					backdrop="static"
					keyboard={false}
					size="lg"
				>
					<Modal.Header closeButton>
						<Modal.Title>
							{/* <span className="err-msg">{indicator && "please fill the fields"}</span> */}
							Add Record
						</Modal.Title>
					</Modal.Header>

					<Modal.Body>
						<Row>
							<Col md={12}>
								<div className="card pt-2 mb-4">
									<div className="card-body">
										<Form>
											{/*dyn  */}
											<Row>
												{Gridcolumns.map(function (i) {
													return (
														i.accessor != "accessor" && (
															<Col md={3}>
																<Form.Group>
																	<div className="date-picker ungroup-date-picker pos-rl">
																		<Form.Label
																			htmlFor="StartDate"
																			title={i.Header}
																		>
																			{/* Since */}
																			{i.accessor != "accessor" ? i.Header : ""}
																			{i.key && (
																				<span className="err-msg">*</span>
																			)}
																		</Form.Label>
																		{i.field && (
																			<IoMdCalendar className="icon date-icon" />
																		)}
																		{i.field && (
																			<DatePicker
																				key={newSales[i.accessor]}
																				selected={
																					newSales[i.accessor]
																						? new Date(
																								moment(
																									newSales[i.accessor]
																								).format("MM/DD/YYYY")
																						  )
																						: new Date()
																				}
																				onChange={(e) =>
																					setNewSales((values) => ({
																						...values,
																						[i.accessor]: e,
																					}))
																				}
																			/>
																		)}
																		{!i.field && (
																			<Form.Control
																				required
																				type="text"
																				name={i.accessor}
																				value={newSales[i.accessor]}
																				key={sales[i.accessor]}
																				onChange={(e) => newhandleChange(e)}
																				disabled={i.disable}
																			/>
																		)}
																	</div>
																</Form.Group>
															</Col>
														)
													);
												})}
											</Row>
											{/*  dyn*/}
										</Form>
									</div>
								</div>
							</Col>
						</Row>

						{/*  */}
					</Modal.Body>
					<Modal.Footer>
						<div className="text-right mt-2">
							<Button
								type="submit"
								disabled={disableSubmit}
								onClick={() => saveRowHandler()}
							>
								<IoMdDoneAll className="icon btn-icon" />
								Save
							</Button>
							<Button
								variant="danger"
								className="ml-3 btn-sm"
								onClick={() => setaddShowConfirm(false)}
							>
								<IoIosClose className="icon btn-icon" />
								Cancel
							</Button>
						</div>
					</Modal.Footer>
				</Modal>
				{/* insert end */}
				{/* Modal */}
				<Modal
					show={showCOnfirm}
					onHide={() => setShowConfirm(false)}
					backdrop="static"
					keyboard={false}
					size="lg"
				>
					<Modal.Header closeButton>
						<Modal.Title>
							{/* <span className="err-msg">{indicator && "please fill the fields"}</span> */}
							Edit Record
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Row>
							<Col md={12}>
								<div className="card pt-2 mb-4">
									<div className="card-body">
										<Form>
											{/*dyn  */}
											<Row>
												{Gridcolumns.map(function (i) {
													return (
														i.accessor != "accessor" && (
															<Col md={3}>
																<Form.Group>
																	<div className="date-picker ungroup-date-picker pos-rl">
																		<Form.Label htmlFor="StartDate">
																			{/* Since */}
																			{i.accessor != "accessor" ? i.Header : ""}
																			{i.key && (
																				<span className="err-msg">*</span>
																			)}
																		</Form.Label>
																		{i.field && (
																			<IoMdCalendar className="icon date-icon" />
																		)}
																		{i.field && (
																			<DatePicker
																				key={sales[i.accessor]}
																				// selected = {i.field)}
																				selected={
																					i.field
																						? new Date(
																								moment(
																									sales[i.accessor]
																								).format("MM/DD/YYYY")
																						  )
																						: new Date()
																				}
																				onChange={(e) =>
																					setSales((values) => ({
																						...values,
																						[i.accessor]: e,
																					}))
																				}
																			/>
																		)}
																		{/* {i.Header.indexOf('Date') == -1  && <Form.Control */}
																		{!i.field && (
																			<Form.Control
																				required
																				type="text"
																				name={i.accessor}
																				value={sales[i.accessor]}
																				// key={cont[i.accessor]}
																				onChange={(e) => handleChange(e)}
																				disabled={i.disable}
																			/>
																		)}
																	</div>
																</Form.Group>
															</Col>
														)
													);
												})}
											</Row>
											{/*  dyn*/}
										</Form>
									</div>
								</div>
							</Col>
						</Row>
					</Modal.Body>
					<Modal.Footer>
						<div className="text-right mt-2">
							<Button
								disabled={addDisableSubmit}
								onClick={() => editRowHandler()}
							>
								<IoMdDoneAll className="icon btn-icon" />
								Edit Row
							</Button>
							<Button
								variant="danger"
								className="ml-3 btn-sm"
								onClick={() => setShowConfirm(false)}
							>
								<IoIosClose className="icon btn-icon" />
								Cancel
							</Button>
						</div>
					</Modal.Footer>
				</Modal>
			</div>

			<Row>
				<Col md={12}>
					{/* <Row> */}
					<span className="mb-4 h6">
						File Name: {outbounddata.File_Process_Name}
					</span>{" "}
					<span className="ml-4 h6">Version: {outbounddata.Fileversion}</span>
					{/* </Row> */}
					<div className="card pt-2">
						<div className="card-body">
							<div className="inventory-grid">
								{hasError ? (
									<p>Error occurred. Unable to load {fileName}</p>
								) : (
									<Fragment>
										{gridData.length > 0 ? (
											<ReactTable
												columns={Gridcolumns}
												data={gridData}
												defaultPageSize={10}
											/>
										) : (
											<div className="no-data">No data found.</div>
										)}
									</Fragment>
								)}
							</div>
						</div>
					</div>
				</Col>
			</Row>
			{/*end  */}
			<Row>
				<Col md={12} className="text-right mt-2">
					{gridData.length > 0 && (
						<Button
							variant="primary"
							type="button"
							onClick={() => saveallRecords()}
						>
							Save Records
						</Button>
					)}
					<Button
						variant="danger"
						type="button"
						className="ml-3"
						onClick={() => history.goBack()}
					>
						<IoIosClose className="icon btn-icon" />
						Cancel
					</Button>
				</Col>
			</Row>
			<Footer />
		</section>
	);
};
export default AptevoQuarterlyServiceFeesEdit;
